import { XandrAdService } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { AlmaB2CCmpService } from "@almamedia/amr-adtech-stack/lib/services/cmp";
import { DataLayerService } from "@almamedia/amr-adtech-stack/lib/services/dataLayer";
import AlmaDmpService from "@almamedia/amr-adtech-stack/lib/services/dmp/almadmp";
import NativeAdsService from "@almamedia/amr-adtech-stack/lib/services/native/native-ads";
import { GravitoService } from "@almamedia/amr-adtech-stack/lib/services/gravito";
import { LazyloadService } from "@almamedia/amr-adtech-stack/lib/services/lazyload";
import { PrebidService } from "@almamedia/amr-adtech-stack/lib/services/prebid/prebid";
import { StackContext } from "./context";
import dataLayer, { ICustomVariables } from "./data-layer/data-layer";
import dmp from "./dmp/dmp";
import ads from "./ads/ads";
import lazyload from "./lazyload/lazyload";
import nativeAds, { SiteNativeTemplate } from "./native/native";
import prebid from "./prebid/prebid";

async function initStack(): Promise<void> {
  const adtechStack: StackContext = { services: {} };

  adtechStack.services.almaCmpService = new AlmaB2CCmpService({}, adtechStack);

  adtechStack.services.gravitoService = new GravitoService(
    { enabled: true },
    adtechStack
  );
  await adtechStack.services.gravitoService.bootstrapService();

  adtechStack.services.dataLayerService = new DataLayerService<
    ICustomVariables,
    SiteNativeTemplate
  >(dataLayer, adtechStack);

  adtechStack.services.almaDmpService = new AlmaDmpService(dmp, adtechStack);
  await adtechStack.services.almaDmpService.init();

  adtechStack.services.lazyloadService = new LazyloadService(
    lazyload,
    adtechStack
  );
  adtechStack.services.lazyloadService.initLazyloader();

  adtechStack.services.nativeAdsService = new NativeAdsService(
    nativeAds,
    adtechStack
  );

  adtechStack.services.prebidService = new PrebidService(prebid, adtechStack);

  adtechStack.services.adsService = new XandrAdService(ads, adtechStack);
  await adtechStack.services.adsService.bootstrapService();
}

initStack();
